import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export class LeftButton extends React.Component {
    render() {
        return (
            <button className="direction-btn -left" onClick={this.props.onClick}>
                <FontAwesomeIcon className="icon" icon="arrow-left"/>
            </button>
        );
    }
}
